// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.events-list[data-v-634dc8b6] {
		height: fit-content;
		max-height: 410px;
		overflow: auto;
}
.events-list-wrapper[data-v-634dc8b6] {
		display: flex;
		flex-direction: column-reverse;
}
& dialog[data-v-634dc8b6] {
		margin: auto;
		border: 0;
		border-radius: 6px;
		min-width: 1024px;
		max-width: 1024px;
		overflow: visible;
&[data-v-634dc8b6]::backdrop {
			background: rgba(0,0,0,.5);
}
}
.site-logs-wrapper[data-v-634dc8b6] {
		min-height: 300px;
		max-height: 720px;
}
.event-log-popup-bar[data-v-634dc8b6] {
		display: flex;
		align-items: center;
		padding-inline: 12px;
		padding-block: 8px;
		line-height: 1;
		background: #FCFCFC;
		border-radius: 4px 4px 0 0;
& span[data-v-634dc8b6] {
			text-transform: capitalize;
}
& button[data-v-634dc8b6] {
			margin-left: auto;
}
}
.event-row[data-v-634dc8b6] {
		display: flex;
		justify-items: center;
		align-items: center;
		text-align: center;
		gap: 8px;
&[data-v-634dc8b6]:not(:last-child) {
			margin-bottom: 4px;
}
}
.event-actions[data-v-634dc8b6] {
		display: flex;
		gap: 6px;
		margin-top: 6px;
& button[data-v-634dc8b6] {
			appearance: none;
			background: #FFF;
			border: 1px solid #CCC;
			position: relative;
			place-content: center;
			padding: 2px 8px;
			border-radius: 4px;
			cursor: pointer;
			font-size: 13px;
			line-height: 1.2;
			transition: background-color 250ms ease-out;
&[data-v-634dc8b6]:after {
				content: '';
				display: block;
				position: absolute;
				inset: 0;
				box-shadow: 0 0 6px rgba(0,0,0,.25);
				opacity: 0;
				transition: opacity 200ms ease-out;
				border-radius: 8px;
				pointer-events: none;
}
@media (hover: hover) and (pointer: fine) {
&[data-v-634dc8b6]:hover {
					background: #EEE;
}
}
& i[data-v-634dc8b6] {
				vertical-align: middle;
}
}
}
.event[data-v-634dc8b6] {
&[data-v-634dc8b6]:not(:first-child) {
			border-bottom: 1px solid #CCC;
			margin-bottom: 8px;
			padding-bottom: 8px;
}
}
.event-type[data-v-634dc8b6] {
		text-transform: capitalize;
}
.event-initiator[data-v-634dc8b6] {
		width: 26px;
		height: 26px;
& img[data-v-634dc8b6] {
			width: 100%;
            border-radius: 50%;
			height: 100%;
			object-fit: contain;
}
}
.submit[data-v-634dc8b6] {
		appearance: none;
		border: 1px solid #b2b2b2;
		border-radius: 4px;
		text-align: center;
		font-size: 12px;
		font-weight: 700;
		cursor: pointer;
		background: #f5f5f5;
		display: inline-block;
		vertical-align: top;
		padding: 4px 7px;
@media (hover: hover) and (pointer: fine) {
&[data-v-634dc8b6]:hover {
				border: 1px solid #888;
}
}
}
`, "",{"version":3,"sources":["webpack://./js/components/wp-depot/EventsList.vue"],"names":[],"mappings":";AAyFA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AACA;AAEA;EACA,aAAA;EACA,8BAAA;AACA;AAEA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAEA;GACA,0BAAA;AACA;AACA;AAEA;EACA,iBAAA;EACA,iBAAA;AACA;AAEA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;AAEA;GACA,0BAAA;AACA;AAEA;GACA,iBAAA;AACA;AACA;AAEA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAEA;GACA,kBAAA;AACA;AACA;AAEA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AAEA;GACA,gBAAA;GACA,gBAAA;GACA,sBAAA;GACA,kBAAA;GACA,qBAAA;GACA,gBAAA;GACA,kBAAA;GACA,eAAA;GACA,eAAA;GACA,gBAAA;GACA,2CAAA;AAEA;IACA,WAAA;IACA,cAAA;IACA,kBAAA;IACA,QAAA;IACA,mCAAA;IACA,UAAA;IACA,kCAAA;IACA,kBAAA;IACA,oBAAA;AACA;AAEA;AACA;KACA,gBAAA;AACA;AACA;AAEA;IACA,sBAAA;AACA;AACA;AACA;AAEA;AACA;GACA,6BAAA;GACA,kBAAA;GACA,mBAAA;AACA;AACA;AAEA;EACA,0BAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;AAEA;GACA,WAAA;YACA,kBAAA;GACA,YAAA;GACA,mBAAA;AACA;AACA;AAEA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAEA;AACA;IACA,sBAAA;AACA;AACA;AACA","sourcesContent":["<template>\n\t<div>\n\t\t<div class=\"events-list\">\n\t\t\t<div class=\"events-list-wrapper\">\n\t\t\t\t<div v-for=\"event of events\" :key=\"event.id\" :class=\"'event ' + event.status\">\n\t\t\t\t\t<div class=\"event-row\">\n\t\t\t\t\t\t<div class=\"event-initiator\">\n\t\t\t\t\t\t\t<img :src=\"`/avatars/${event.initiator}.jpg`\" :alt=\"event.initiator\" width=\"26\" height=\"26\"/>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<p class=\"event-type\">{{ renderTitle(event) }}</p>\n\n\t\t\t\t\t\t<p v-if=\"['pending', 'in-progress'].includes(event.status)\">\n\t\t\t\t\t\t\t<i class=\"fa fa-spinner fa-spin\"></i>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"event-actions\">\n\t\t\t\t\t\t<button @click=\"handleViewLogs(event)\" title=\"View Logs\">Logs</button>\n\n\t\t\t\t\t\t<button @click=\"handleLink(event.meta.archive_url)\" v-if=\"event.meta.archive_url && event.status === 'completed'\" title=\"Download Archive\">Download ZIP</button>\n\n\t\t\t\t\t\t<button @click=\"handleLink(event.meta.logs_url)\" v-if=\"event.meta.logs_url && event.status === 'completed'\" title=\"View Archive Logs\">Archived file index</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<dialog @click=\"$refs.dialog.close()\" ref=\"dialog\" class=\"event-log-popup\" v-show=\"focusedEvent !== null\">\n\t\t\t<div @click.stop class=\"event-log-popup-inner\">\n\t\t\t\t<div class=\"event-log-popup-bar\">\n\t\t\t\t\t<p>Logs for <span>{{ focusedEvent?.type }}</span> event initiated by {{ focusedEvent?.initiator }}</p>\n\n\t\t\t\t\t<button class=\"submit\" @click=\"$refs.dialog.close()\">Close</button>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"site-logs-wrapper\">\n\t\t\t\t\t<SiteLogs :initPolling=\"focusedEvent?.status === 'in-progress' || focusedEvent?.status === 'pending'\" :eventId=\"focusedEvent?.id\" :siteId=\"siteId\" :wpDepotId=\"wpDepotId\" @statusChange=\"handleStatusChange\"/>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</dialog>\n\t</div>\n</template>\n\n<script>\nimport SiteLogs from './SiteLogs.vue';\n\nexport default {\n    components: { SiteLogs },\n    props: ['events', 'siteId', 'wpDepotId'],\n\temits: ['statusChange'],\n    data() {\n        return {\n            focusedEvent: this.events.find(event => event.status === 'in-progress') ?? null\n        };\n    },\n    methods: {\n        renderTitle(event) {\n            const type = event.type;\n\n            let title = type;\n            if (type === 'install') {\n                title = 'Site installed from GIT';\n            } else if (type === 'create') {\n                title = 'WP instance created ';\n            } else if (type === 'archive') {\n                title = 'WP package created ';\n            } else if (type === 'change-php-version') {\n                title = 'Site PHP version changed.';\n            }\n\n            return `[${renderTimestamp(event.created_at)}] ${title}`;\n        },\n\n        handleViewLogs(event) {\n            this.focusedEvent = event;\n\t\t\tthis.$refs.dialog.showModal();\n        },\n\t\thandleStatusChange(newStatus, siteData) {\n\t\t\tthis.$emit('statusChange', newStatus, siteData);\n\t\t},\n\t\thandleLink(link) {\n\t\t\twindow.open(link, '_blank');\n\t\t}\n    }\n}\n</script>\n\n<style scoped>\n\t.events-list {\n\t\theight: fit-content;\n\t\tmax-height: 410px;\n\t\toverflow: auto;\n\t}\n\n\t.events-list-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column-reverse;\n\t}\n\n\t& dialog {\n\t\tmargin: auto;\n\t\tborder: 0;\n\t\tborder-radius: 6px;\n\t\tmin-width: 1024px;\n\t\tmax-width: 1024px;\n\t\toverflow: visible;\n\n\t\t&::backdrop {\n\t\t\tbackground: rgba(0,0,0,.5);\n\t\t}\n\t}\n\n\t.site-logs-wrapper {\n\t\tmin-height: 300px;\n\t\tmax-height: 720px;\n\t}\n\n\t.event-log-popup-bar {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding-inline: 12px;\n\t\tpadding-block: 8px;\n\t\tline-height: 1;\n\t\tbackground: #FCFCFC;\n\t\tborder-radius: 4px 4px 0 0;\n\n\t\t& span {\n\t\t\ttext-transform: capitalize;\n\t\t}\n\n\t\t& button {\n\t\t\tmargin-left: auto;\n\t\t}\n\t}\n\n\t.event-row {\n\t\tdisplay: flex;\n\t\tjustify-items: center;\n\t\talign-items: center;\n\t\ttext-align: center;\n\t\tgap: 8px;\n\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: 4px;\n\t\t}\n\t}\n\n\t.event-actions {\n\t\tdisplay: flex;\n\t\tgap: 6px;\n\t\tmargin-top: 6px;\n\n\t\t& button {\n\t\t\tappearance: none;\n\t\t\tbackground: #FFF;\n\t\t\tborder: 1px solid #CCC;\n\t\t\tposition: relative;\n\t\t\tplace-content: center;\n\t\t\tpadding: 2px 8px;\n\t\t\tborder-radius: 4px;\n\t\t\tcursor: pointer;\n\t\t\tfont-size: 13px;\n\t\t\tline-height: 1.2;\n\t\t\ttransition: background-color 250ms ease-out;\n\n\t\t\t&:after {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tinset: 0;\n\t\t\t\tbox-shadow: 0 0 6px rgba(0,0,0,.25);\n\t\t\t\topacity: 0;\n\t\t\t\ttransition: opacity 200ms ease-out;\n\t\t\t\tborder-radius: 8px;\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\n\t\t\t@media (hover: hover) and (pointer: fine) {\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: #EEE;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& i {\n\t\t\t\tvertical-align: middle;\n\t\t\t}\n\t\t}\n\t}\n\n\t.event {\n\t\t&:not(:first-child) {\n\t\t\tborder-bottom: 1px solid #CCC;\n\t\t\tmargin-bottom: 8px;\n\t\t\tpadding-bottom: 8px;\n\t\t}\n\t}\n\n\t.event-type {\n\t\ttext-transform: capitalize;\n\t}\n\n\t.event-initiator {\n\t\twidth: 26px;\n\t\theight: 26px;\n\n\t\t& img {\n\t\t\twidth: 100%;\n            border-radius: 50%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: contain;\n\t\t}\n\t}\n\n\t.submit {\n\t\tappearance: none;\n\t\tborder: 1px solid #b2b2b2;\n\t\tborder-radius: 4px;\n\t\ttext-align: center;\n\t\tfont-size: 12px;\n\t\tfont-weight: 700;\n\t\tcursor: pointer;\n\t\tbackground: #f5f5f5;\n\t\tdisplay: inline-block;\n\t\tvertical-align: top;\n\t\tpadding: 4px 7px;\n\n\t\t@media (hover: hover) and (pointer: fine) {\n\t\t\t&:hover {\n\t\t\t\tborder: 1px solid #888;\n\t\t\t}\n\t\t}\n\t}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
